module.exports = __webpack_public_path__ + "img/小资讯1.5b724ceb.png";